import { combineReducers } from "redux";

// auth + errors + appMessage slices (SCRUM-1950: RTK bundle 1, the app shell)
import authReducer from "./userServices/authSlice";
import errorReducer from "./errorServices/errorsSlice";
// users slice (SCRUM-1024: createSlice migration, boy-scout under the bare-RTK standard)
import usersReducer from "./userServices/usersSlice";
import siteReducer from "./siteServices/sitesSlice";
import translationReducer from "./translationservice/translationSlice";

// profile slice (SCRUM-1024: createSlice migration, boy-scout under the bare-RTK standard)
import profileReducer from "./userServices/profileSlice";
import designReducer from "./designServices/designSlice";
import productReducer from "./productServices/productSlice";
import templateReducer from "./templateServices/templateSlice";
import categoryReducer from "./categoryServices/categorySlice";
import pageReducer from "./pageServices/pagesSlice";
import blogReducer from "./blogServices/blogSlice";
import clientReducer from "./clientService/clientSlice";
import variableReducer from "./variableServices/variableSlice";
import pendingPages from "./pendingPagesServices/pendingPagesSlice";
import adReducer from "./adServices/adSlice";
import histories from "./historiesServices/historiesSlice";
import imagesReducer from "./ImageServices/ImageSlice";
import productPropertiesReducer from "./productPropertiesServices/ProductPropertiesSlice";
// historiespages slice (SCRUM-1014: createSlice migration, SCRUM-652 worked example)
import historiesPagesReducer from "./historiesPagesServices/historiesPagesSlice";
import pendingChangesReducer from "./pendingChangesServices/pendingChangesSlice"
import appMessageReducer from "./appMessageServices/appMessageSlice"
// SCRUM-1753: the held form submissions a reviewer releases or discards.
import heldSubmissionsReducer from "./heldSubmissionsServices/heldSubmissionsSlice"
export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  // Transient success/status messages, kept off the errors slice (SCRUM-882).
  appMessage: appMessageReducer,
  users: usersReducer,
  sites: siteReducer,
  profile: profileReducer,
  designs: designReducer,
  products: productReducer,
  productproperties: productPropertiesReducer,
  templates: templateReducer,
  categories: categoryReducer,
  pages: pageReducer,
  blog: blogReducer,
  clients: clientReducer,
  variables: variableReducer,
  pendingPages: pendingPages,
  ad: adReducer,
  histories: histories,
  images: imagesReducer,
  // new reducer
  historiespages: historiesPagesReducer,
  translatedpages: translationReducer,
  pendingChanges: pendingChangesReducer,
  heldSubmissions: heldSubmissionsReducer,
});
